<template>
  <!-- The item's address in the source. A number names itself; a meeting has
       nothing to name, so it renders as an icon with an accessible name.
       Click stops at the link — the card around it opens the wizard. -->
  <a
    v-if="link"
    class="tc-source-link"
    :class="{ 'tc-source-link--icon': !link.ref }"
    :href="link.href"
    :title="link.title"
    :aria-label="link.ref ? undefined : link.title"
    target="_blank"
    rel="noopener noreferrer"
    data-testid="source-link"
    @click.stop
  >
    <template v-if="link.ref">{{ link.ref }}</template>
    <svg v-else viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path d="M6.5 3H13v6.5M13 3L7 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M11 11.5v1a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5h1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
  </a>
</template>

<script setup lang="ts">
import type { SourceLink } from '../sourceFacts';

defineProps<{ link: SourceLink | null }>();
</script>
